import { PolicyPage } from "@/components/PolicyPage";

export default function Privacy() {
  return <PolicyPage policyType="privacy" title="Privacy Notice" testid="privacy-page" />;
}
